import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin } from "antd";
import Attendance from "./Attendance";
import AssignStaff from "./AssignStaff";
import Close from "./CloseGroup";
import GroupSavingsApplication from "./groupSavingsApp/GroupSavingsApplication";
import ActivateGroup from "./ActivateGroup";
import GroupLoanApplication from "./groupLoanApplication/GroupLoanApplication";
import AttachMeeting from "./AttachMeeting";
import GLIMLoanApplication from "./GLIM Loan Application/GLIMLoanApplication";
import NewGsimApplication from "./gsimApplication/NewGsimApplication";

const { TextArea } = Input;
const GroupsMainActionPage = (props) => {
  const { userData } = props;
  const { state } = useLocation();

  useEffect(() => {
    // console.log(state);
  }, []);

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      case "attendance":
        return <Attendance userData={userData} />;
      case "assign staff":
        return <AssignStaff userData={userData} />;
      case "close":
        return <Close userData={userData} />;
      case "group savings application":
        return <GroupSavingsApplication userData={userData} />;
      case "activate":
        return <ActivateGroup userData={userData} />;
      case "group loan application":
        return <GroupLoanApplication userData={userData} />;
      case "attach meeting":
        return <AttachMeeting userData={userData} />;
      case "group loan (individual monitoring) application":
        return <GLIMLoanApplication userData={userData} />;
      case "group savings (individual monitoring) application":
        return <NewGsimApplication userData={userData} />;

      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(GroupsMainActionPage);
